import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';
import { AuthProvider } from './context/AuthContext';

// Recuperacao automatica em ChunkLoadError (bundle antigo aberto em aba antes de novo deploy
// tenta carregar chunk lazy que nao existe mais). Sem isso, tela branca ate Ctrl+F5 manual.
// Guardamos 1 tentativa por sessao pra evitar reload-loop.
if (typeof window !== 'undefined') {
  const isChunkLoadError = (err) => {
    const msg = (err && (err.message || err.toString())) || '';
    const name = (err && err.name) || '';
    return name === 'ChunkLoadError' || /Loading chunk [\d]+ failed/i.test(msg) || /Loading CSS chunk/i.test(msg);
  };
  const tryReload = () => {
    try {
      const key = '_chunkReloadTried';
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
      const u = new URL(window.location.href);
      u.searchParams.set('_nocache', Date.now().toString());
      window.location.replace(u.toString());
    } catch (_) { window.location.reload(); }
  };
  window.addEventListener('unhandledrejection', (e) => { if (isChunkLoadError(e && e.reason)) { tryReload(); } });
  window.addEventListener('error', (e) => { if (isChunkLoadError(e && (e.error || e))) { tryReload(); } });
}


const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <App />
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
